<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadDatabases(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addDatabase">{{ $t('add_database') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('host')" v-model="databasesSearchParams.host" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('db_name')" v-model="databasesSearchParams.db_name" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadDatabases(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="databaseDataContainer" :title="$t('databases')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-servers-tab-nav></shared-servers-tab-nav>
      </template>

      <vs-table hover-flat v-if="databases && databases.length" :data="databases">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('host')"></vs-th>
          <vs-th v-text="$t('db_name')"></vs-th>
          <vs-th class="text-center" v-text="$t('test_connection')"></vs-th>
          <vs-th v-text="$t('label')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.host"></vs-td>
            <vs-td v-text="tr.name"></vs-td>
            <vs-td class="text-center">
              <badge-db-test-connection :result="tr.test_connection"></badge-db-test-connection>
            </vs-td>
            <vs-td v-text="tr.label"></vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="editDatabase(tr.id)"></vs-button>&nbsp;
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="deleteDatabase(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="databasePages"
          :itemPerPage="itemPerPage"
          :click-handler="loadDatabases"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_database')" :active.sync="modals.add" size="lg">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <label class="vs-input--label" v-text="$t('database_type')"></label>
            <v-select :options="databaseTypeOptions" :reduce="label => label.value" :placeholder="$t('database_type')" v-model="databaseFormData.database_type_id" class="md:mb-0" />
            <validation-error :model-error="databaseFormErrors.database_type_id"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('db_name')" :placeholder="$t('db_name')" v-model="databaseFormData.name" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.name"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('host')" :placeholder="$t('host')" v-model="databaseFormData.host" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.host"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('port')" :placeholder="$t('port')" v-model="databaseFormData.port" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.host"></validation-error>
          </div>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('username')" :placeholder="$t('username')" v-model="databaseFormData.username" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.username"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('password')" type="password" :placeholder="$t('password')" v-model="databaseFormData.password" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.password"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('password_confirm')" type="password" :placeholder="$t('password_confirm')" v-model="databaseFormData.password_confirmation" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.password_confirmation"></validation-error>
          </div>
          <div class="mb-3">
            <vs-input :label="$t('label')" :placeholder="$t('label')" v-model="databaseFormData.label" class="w-full"/>
            <validation-error :model-error="databaseFormErrors.label"></validation-error>
          </div>
        </div>
      </div>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addDatabaseButton" color="primary" type="filled" @click.prevent="submitDatabase">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_database')" :active.sync="modals.edit" size="lg">
      <div id="databaseEditFormDataContainer" class="vs-con-loading__container">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <div class="mb-3">
              <label class="vs-input--label" v-text="$t('database_type')"></label>
              <v-select :options="databaseTypeOptions" :reduce="label => label.value" :placeholder="$t('database_type')" v-model="databaseFormData.database_type_id" class="md:mb-0" />
              <validation-error :model-error="databaseFormErrors.database_type_id"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('db_name')" :placeholder="$t('db_name')" v-model="databaseFormData.name" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.name"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('host')" :placeholder="$t('host')" v-model="databaseFormData.host" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.host"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('port')" :placeholder="$t('port')" v-model="databaseFormData.port" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.host"></validation-error>
            </div>
          </div>

          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
            <div class="mb-3">
              <vs-input :label="$t('username')" :placeholder="$t('username')" v-model="databaseFormData.username" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.username"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('password')" type="password" :placeholder="$t('password')" v-model="databaseFormData.password" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.password"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('password_confirm')" type="password" :placeholder="$t('password_confirm')" v-model="databaseFormData.password_confirmation" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.password_confirmation"></validation-error>
            </div>
            <div class="mb-3">
              <vs-input :label="$t('label')" :placeholder="$t('label')" v-model="databaseFormData.label" class="w-full"/>
              <validation-error :model-error="databaseFormErrors.label"></validation-error>
            </div>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editDatabaseButton" color="primary" type="filled" @click.prevent="updateDatabase">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SharedServersTabNav from '@/views/Shared/Servers/TabNav'
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import BadgeDbTestConnection from '@/components/badge/DbTestConnection'
import Database from '@/models/Database'

export default {
  name: 'Admin.Servers.Databases',
  mixins: [Pagination],
  components: {
    SharedServersTabNav,
    Paginate,
    Modal,
    BadgeDbTestConnection
  },
  data () {
    return {
      databases: {},
      databasePages: 0,
      databaseTypeOptions: [],
      databaseFormData: {
        name: '',
        database_type_id: '',
        host: '',
        port: '',
        username: '',
        password: '',
        password_confirmation: '',
        label: ''
      },
      itemPerPage: null,
      databaseFormErrors: [],
      databasesSearchParams: {
        host: '',
        db_name: ''
      },
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetDatabaseForm()
      }
    },
    'modals.edit' (val) {
      if (!val) {
        this.resetDatabaseForm()
      }
    }
  },
  mounted () {
    this.loadDatabases(this.initialPage, null)
  },
  methods: {
    async loadDatabases (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#databaseDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await Database.findAll({ ...this.databasesSearchParams, page, itemPerPage })
      this.databases = response.data.data
      this.databasePages = response.data.meta.pagination.last_page
      this.databaseTypeOptions = response.data.meta.options.databaseTypes
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#databaseDataContainer > .con-vs-loading')
    },
    addDatabase () {
      this.modals.add = true
    },
    async submitDatabase () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addDatabaseButton', scale: 0.45})

      try {
        const response = await Database.store(this.databaseFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadDatabases(1, null)
        this.resetDatabaseForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.databaseFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addDatabaseButton > .con-vs-loading')
    },
    async editDatabase (id) {
      this.$vs.loading({container: '#databaseEditFormDataContainer'})

      try {
        this.modals.edit = true
        const response = await Database.view({ id })
        this.databaseFormData = response.data.database
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#databaseEditFormDataContainer > .con-vs-loading')
    },
    async updateDatabase () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editDatabaseButton', scale: 0.45})

      try {
        const response = await Database.update(this.databaseFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.edit = false

        this.loadDatabases()
        this.resetDatabaseForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.databaseFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#editDatabaseButton > .con-vs-loading')
    },
    async deleteDatabase (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await Database.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadDatabases(1, null)
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },

    resetDatabaseForm () {
      this.databaseFormData = {
        name: '',
        database_type_id: '',
        host: '',
        port: '',
        username: '',
        password: '',
        password_confirmation: '',
        label: ''
      }
      this.databaseFormErrors = []
    }
  }
}
</script>

<style lang="scss">
  #addDatabaseButton,
  #editDatabaseButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
